// @ts-ignore
import CircularStdBook from './CircularStd/CircularStd-Book.woff2';
// @ts-ignore
import CircularStdMedium from './CircularStd/CircularStd-Medium.woff2';
// @ts-ignore
import CircularStdBold from './CircularStd/CircularStd-Bold.woff2';
// @ts-ignore
import CircularStdBlack from './CircularStd/CircularStd-Black.woff2';

const fonts = `
  @font-face {
    font-family: 'CircularStd';
    font-weight: 400;
    src: local('CircularStd'), local('CircularStd-Book'), url(${CircularStdBook}) format('woff2');
  }
  @font-face {
    font-family: 'CircularStd';
    font-weight: 500;
    src: local('CircularStd'), local('CircularStd-Medium'), url(${CircularStdMedium}) format('woff2');
  }
  @font-face {
    font-family: 'CircularStd';
    font-weight: 700;
    src: local('CircularStd'), local('CircularStd-Bold'), url(${CircularStdBold}) format('woff2');
  }
  @font-face {
    font-family: 'CircularStd';
    font-weight: 800;
    src: local('CircularStd'), local('CircularStd-Black'), url(${CircularStdBlack}) format('woff2');
  }
  `;

export default fonts;
